import React, { useState, useEffect } from 'react'
// navigation not required here
import { motion } from "framer-motion";
import AdsService from '../../../../../services/Ads';
import AdsCart from '../../../ads/modules/AdsCart';
import { timeAgo } from '../../../../../utiels/functions/persianFormat';
import EditModal from './EditModal';
import { formatNumberForDisplay } from '../../../../../utiels/functions/persianFormat';
import DeleteModal from '../../../../../Modals/delete modal/DeleteModal';
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from 'react-redux';
import { showToast } from '../../../../../redux/slices/toastSlice';




export default function CardAd({ cargos, setAds, isEditOpen, setIsEditOpen }) {
    const [adsList, setAdsList] = useState([]);
    console.log(adsList)
    // loading state isn't used in UI here

    // named fetch so child can request a refresh after save/delete
    const fetchMyAds = async () => {
        try {
            const res = await AdsService.myAds();
            setAdsList(res?.data?.data || []);
            console.log('Fetched my ads successfully:', res?.data?.data);
        } catch (err) {
            console.warn('Could not fetch my ads:', err);
            setAdsList([]);
            console.error('Error fetching my ads:', err);
        }
    };

    useEffect(() => {
        let mounted = true;
        if (mounted) fetchMyAds();
        return () => { mounted = false; };
    }, []);


    return (
        <div className="w-full min-h-[80vh] overflow-y-auto ">
            <div className="grid gap-6 grid-cols-1 pb-5  min-h-full overflow-y-auto sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
                {
                    adsList.map((ad, index) => (
                        <motion.div
                            key={ad._id || index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.06 }}
                            className="w-full"
                        >
                            <AdCard setAds={setAds} isEditOpen={isEditOpen} setIsEditOpen={setIsEditOpen} ad={ad} refreshAds={fetchMyAds} />
                        </motion.div>
                    ))
                }
            </div>
        </div>
    );
}


function AdCard({ ad, refreshAds, isEditOpen, setAds, setIsEditOpen }) {
    const id = ad?._id || ad?.id;
    const image = ad?.image?.path || (Array.isArray(ad?.image) ? (ad.image[0]?.path || ad.image[0]) : ad?.image) || "";
    const title = ad?.title || "بدون عنوان";
    const description = ad?.description || "بدون توضیحات";
    const price = formatNumberForDisplay(ad?.price) || "تماس بگیرید";
    const dealType = ad?.type || ad?.dealType || "sales";
    const postedHoursAgo = timeAgo(ad?.createdAt);
    const isSaved = ad?.isSaved || false;



    const [] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    function handleDeleteClick(adId) {
        setDeleteTarget(adId);
        setDeleteModalOpen(true);
    }



    // ad.status = "confirmed";

    let status = "رد شده";
    if (ad?.status === "pending") status = "در انتظار تأیید";
    else if (ad?.status === "confirmed") status = "تأیید شده";

    const dispatch = useDispatch()


    return (
        <>


            {deleteModalOpen && (
                <DeleteModal
                    open={deleteModalOpen}
                    onClose={() => { setDeleteModalOpen(false); setDeleteTarget(null); }}
                    isDeleting={isDeleting}
                    title="آیا مطمئن هستید که می‌خواهید این آگهی را حذف کنید؟"
                    action={async () => {
                        if (!deleteTarget) return;
                        try {
                            setIsDeleting(true);
                            await AdsService.deleteMyAd({ RentalSaless: deleteTarget });
                            await refreshAds();
                            dispatch(showToast({ message: "آگهی با موفقیت حذف شد", type: "success" }));

                        } catch (err) {
                            console.error('Error deleting ad:', err);
                            dispatch(showToast({ message: "خطا در حذف آگهی", type: "error" }));

                        } finally {
                            setIsDeleting(false);
                            setDeleteModalOpen(false);
                            setDeleteTarget(null);
                        }
                    }}
                />
            )}
            <div className="rounded-[30px] hover:translate-y-1 transition duration-200 text-special w-full bg-white border-[1px] border-gray-200 h-max shadow-md flex flex-col justify-between items-end px-1 py-4">
                <div className="flex flex-row gap-2 w-auto  items-center mx-5">
                    <div className={`flex justify-center gap-2 rounded-lg w-[100px] h-[20px] py-1 px-1 bg-opacity-70 backdrop-blur-2xl ${ad?.status === 'pending' ? ' bg-gray-400' : ad?.status === 'confirmed' ? ' bg-green-500' : 'bg-red-500'}`}>
                        <p className={` rounded-full lg:text-[10px] text-[8px] text-white`}> وضعیت: </p>
                        <p className={` rounded-full lg:text-[10px] text-[8px] text-white`}>{status}</p>

                    </div>
                </div>

                <AdsCart hasBorder={false} id={id} image={image} title={title} description={description} price={price} dealType={dealType} postedHoursAgo={postedHoursAgo} isSaved={isSaved} />

                <div className="w-full mt-2 sm:mt-0 px-5 gap-2 flex justify-center">
                    <button
                        onClick={() => handleDeleteClick(id)}
                        className={`
                    w-[40%] whitespace-nowrap lg:text-[16px] 
                    text-[14px] rounded-full h-[27px] bg-red-300 text-red-600 
                    hover:text-white hover:bg-red-500 border-[1px] border-red-600 
                    text-center flex items-center justify-center gap-1 px-1
                `}
                    >
                        <RxCross2 className="w-4 h-4" />
                        <span>حذف آگهی</span>
                    </button>

                    <button
                        onClick={() => {
                            setAds(ad);
                            setTimeout(() => setIsEditOpen(true), 50);
                        }}
                        className={`
                    w-[55%] whitespace-nowrap lg:text-[16px] 
                    text-[14px] rounded-full h-[27px] bg-white text-special 
                    hover:text-white hover:bg-special border-[1px] border-special 
                    text-center flex items-center justify-center gap-1 px-1 
                `}
                    >
                        <span>ویرایش  آگهی</span>
                    </button>
                </div>


                {/* Modal: now modal will handle the edit form and update logic internally; we just signal refresh after save */}
                {/* {isEditOpen && (
                    <EditModal isOpen={isEditOpen} ad={ad} onClose={() => setIsEditOpen(false)} onSave={async () => {
                        // let EditModal perform save and then refresh
                        if (typeof refreshAds === 'function') await refreshAds();
                        setIsEditOpen(false);
                    }} />
                )} */}

                {/* Delete confirmation modal (state-driven) */}

            </div>
        </>
    );
}

